import { Species } from "./Species";
import { ConsignmentDay } from "./ConsignmentDay";
import { ConsignmentDeck } from "./ConsignmentDeck";
import de from "date-fns/esm/locale/de/index.js";

export class FeedPerDeck {
    id;
    FeedDetailID;
    NumberOfHead;
    IsManualWatering;
    Pellets;
    Grain;
    Roughage;
    Species;
    ConsignmentDay;
    ConsignmentDeck;

    constructor({ id,
        feedDetailID,
        numberOfHead,
        isManualWatering,
        pellets,
        grain,
        roughage,
        species, consignmentDay, consignmentDeck }) {
        this.id = id;
        this.FeedDetailID = feedDetailID;
        this.NumberOfHead = numberOfHead;
        this.IsManualWatering = isManualWatering;
        this.Pellets = pellets;
        this.Grain = grain;
        this.Roughage = roughage;
        this.Species = new Species(species);
        this.ConsignmentDay = new ConsignmentDay(consignmentDay);
        this.ConsignmentDeck = new ConsignmentDeck(consignmentDeck);
    }

    static convertFeedPerDeck(record) {
        return {
            id: record.ID,
            feedDetailID: record.feedDetailID,
            numberOfHead: record.numberOfHead,
            isManualWatering: record.isManualWatering,
            pellets: record.pellets,
            grain: record.grain,
            roughage: record.roughage,
            species: record.Species, 
            consignmentDay: record.ConsignmentDay,
            consignmentDeck: record.ConsignmentDeck, 
        };
    }
}